import { ReactElement, useEffect, useState } from 'react';
import { segmentsTracking } from '../lib/tracker';
import { FormattedMessage } from 'react-intl';
import '../style/FeedbackModal.scss';
import '../style/common.scss';
import { ThumbsDown32, ThumbsUp32 } from '@carbon/icons-react';
import FeedbackModal from './FeedbackModal';

export interface feedbackProperties {
  pageTitle: string;
  object: string;
  messages: any;
  productTitle: string;
  pageUrl: string;
  emailJson: string;
}

const Feedback = ({
  pageTitle,
  object,
  messages,
  productTitle,
  pageUrl,
  emailJson,
}: feedbackProperties): ReactElement => {
  const [showModal, setShowModal] = useState(false);
  const [thumbsUp, setThumbsUp] = useState(true);

  const render = (
    <div className="FeedbackModal">
      <div className="bx--row">
        <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16 mar1">
          <FormattedMessage {...messages.feedBackText} />
          <ThumbsUp32
            className="FeedbackModal-thumbsUp space8_left"
            tabIndex="0"
            aria-label="add"
            onClick={() => {
              segmentsTracking('CTA Clicked', {
                productTitle,
                pageTitle,
                object,
                pageUrl,
                resultValue: 'CTA clicked',
                CTA: 'Thumbs up clicked',
                location: 'Estimator',
                action: '',
                field: '',
              });
              setThumbsUp(true);
              setShowModal(true);
            }}
          />{' '}
          <FormattedMessage {...messages.feedBackHelpfull} />
          <ThumbsDown32
            className="FeedbackModal-thumbsDown space8_left"
            tabIndex="1"
            onClick={() => {
              segmentsTracking('CTA Clicked', {
                productTitle,
                pageTitle,
                object,
                pageUrl,
                resultValue: 'CTA clicked',
                CTA: 'Thumbs down clicked',
                location: 'Estimator',
                action: '',
                field: '',
              });
              setThumbsUp(false);
              setShowModal(true);
            }}
          />{' '}
          <FormattedMessage {...messages.feedBackNotHelpfull} />
          <FeedbackModal
            pageTitle={pageTitle}
            object={object}
            messages={messages}
            productTitle={productTitle}
            pageUrl={pageUrl}
            emailJson={emailJson}
            showFeedbackModal={showModal}
            thumbsUp={thumbsUp}
            setShowFeedbackModal={setShowModal}
          ></FeedbackModal>
        </div>
      </div>
    </div>
  );
  return render;
};

export default Feedback;
